import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardContent, Container, Typography } from "@mui/material";
// Footer removed to give more space for orders view
// import Navbar from "../components/Navbar";
import "../AppPanel.css";
import "./MyProfile.css";
import Sidebar from "../components/Sidebar/Sidebar";
// import MainDash from "../components/MainDash/MainDash";
import { useEffect } from "react";
import { fetchUserOrders, updateOrder } from "../redux/myOrdersRedux";
import { Switch, Route, useRouteMatch, Redirect } from "react-router-dom";
import { SidebarData } from "../Sidebar/SidebarData";
import Layout from "../components/Global/Layout";
import { createUserSocket } from "../utils/userSocket";

const MyProfile = () => {
  const user = useSelector((state) => state.user.currentUser);
  // console.log('MyProfile - user:', user);

  // Support both email auth (user.result._id) and normalized phone/google auth (user._id)
  const client_id = user?.result?._id || user?._id;
  // console.log('MyProfile - client_id:', client_id);

  let { path } = useRouteMatch();

  const dispatch = useDispatch();

  // Get User's Orders
  useEffect(() => {
    if (client_id) {
      dispatch(fetchUserOrders(client_id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [client_id]);

  // Socket connection for real-time order updates
  useEffect(() => {
    if (!client_id) return;

    // Carries the customer's token: their rooms need it (utils/userSocket.js).
    const socket = createUserSocket();

    socket.on("connect", () => {
      console.log("[MyProfile] Socket connected, joining order room...");
      // Join the order room for this client to receive order updates
      socket.emit("join", `orderRoom:${client_id}`);
    });

    // Listen for real-time order updates
    socket.on("orderUpdate", (updatedOrder) => {
      console.log("[MyProfile] Received orderUpdate:", updatedOrder?._id, updatedOrder?.delivery_status);
      dispatch(updateOrder(updatedOrder));
    });

    socket.on("disconnect", () => {
      console.log("[MyProfile] Socket disconnected");
    });

    // Cleanup on unmount
    return () => {
      socket.off("orderUpdate");
      socket.disconnect();
    };
  }, [client_id, dispatch]);

  return (
    <>
      <Layout>
        {/* <Navbar /> */}
        <Container maxWidth="lg" className="profile-container" style={{ marginTop: "0", marginBottom: "40px" }}>
          <Card sx={{ minWidth: 275, boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)", borderRadius: "12px" }}>
            <CardContent style={{ padding: "16px 16px 0 16px" }}>
              <Typography
                variant="h5"
                component="div"
                style={{
                  background: "linear-gradient(135deg, #017109 0%, #015a07 100%)",
                  borderRadius: "12px",
                  padding: "16px 20px",
                  color: "white",
                  fontWeight: 700,
                  fontSize: "24px",
                  fontFamily: "'Poppins', sans-serif",
                  boxShadow: "0 4px 12px rgba(1, 113, 9, 0.15)",
                }}
              >
                {user?.result?.name || user?.name || user?.result?.businessName}'s Profile
              </Typography>
            </CardContent>
            {/* DASHBOARD*/}
            <div className="AppPanel">
              <div className="AppGlass">
                <Sidebar />
                <div className="mainContent">
                  <Switch>
                    <Route exact path={path}>
                      <Redirect to={`${path}/my_orders`} />
                    </Route>
                    {SidebarData.map((item, index) => (
                      <Route
                        key={index}
                        path={`${path}${item.path}`}
                        exact
                        component={item.component}
                      />
                    ))}
                  </Switch>
                </div>
                {/* <MainDash /> */}
              </div>
            </div>
          </Card>
        </Container>
      </Layout>
      {/* <Footer /> */}
    </>
  );
};

export default MyProfile;
